import React from "react";
import ForgetPasswordPage from "../../components/templates/forgetPasswordPage/ForgetPasswordPage";

const ForgetPassword = () => {
  return <ForgetPasswordPage />;
};

export default ForgetPassword;
